<template>
  <div class="brand-form-media">
    <a class="btn text-themed go-back" @click="goBack()">{{ $t("flexben.general.go_back") }}</a>
    <div class="row">
      <div class="col-12 col-md-6 flexben-page-title">
        <h1>{{ (formAction === 'create') ? $t('flexben.brand.new') : $t('flexben.brand.edit') }}</h1>
      </div>
      <div class="col-12 col-md-6 text-right">
        <button class="btn text-danger px-4" v-if="(formAction === 'update')" @click="modalAct('delete')">
          <font-awesome-icon icon="trash-alt"/>
          {{$t("flexben.general.btn.delete")}}
        </button>
        <button class="btn btn-themed px-4" @click="modalAct('form_submit')">
          {{ $t('flexben.general.btn.save') }}
        </button>
      </div>
    </div>
    <div class="row my-1" v-if="checkNotEmptyObj(errorsBag)">
      <div class="col-12">
        <div class="alert alert-danger alert-dismissible mb-0">
          <button type="button" class="close" data-dismiss="alert">&times;</button>
          <form-error-list :errorBag="errorsBag" />
        </div>
      </div>
    </div>
    <div class="container-bg-white mt-3">
      <div class="row px-3">
        <div class="col-12">
          <h3 class="m-0 pl-0">{{ $t('flexben.general.details') }}</h3>
        </div>
        <div class="col-12 col-lg-4 mb-4 mb-lg-0">
          <div class="upload-card primary-upload-card">
            <div class="upload-card-header">
              <div>
                <h4 class="upload-title mb-1">{{ $t('flexben.brand.fields.icon') }}</h4>
                <p class="upload-subtitle m-0">{{ $t('flexben.formErrorReasons.required') }}</p>
              </div>
              <span class="required-badge">{{ $t('flexben.formErrorReasons.required') }}</span>
            </div>

            <div class="upload-card-body">
              <label class="label-input w-100 mb-2">{{ $t('flexben.brand.fields.icon') }}</label>
              <vue2Dropzone
                  ref="iconUrlRef"
                  id="iconUrl"
                  :options="dropzoneOptions.icon"
                  @vdropzone-removed-file="onIconRemoved"
                  @vdropzone-file-added="onIconAdded"
              />
              <div v-if="errors.icon_url" class="text-danger mt-2">
                {{ errors.icon_url }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-xl-8">
          <div class="row">
            <div class="col-12 col-md-6 form-group">
              <label for="name" class="form-fields-required col-form-label">
                {{ $t('flexben.brand.fields.name') }}
              </label>
              <input type="text" class="form-control" id="name" v-model="formData.name"
                     :class="{'border-danger':(Object.keys(errorsBag).includes('name'))}"
              />
            </div>
            <div class="col-12 col-md-6 form-group">
              <label for="site" class="col-form-label">{{ $t('flexben.brand.fields.website') }}</label>
              <input
                  type="text"
                  class="form-control"
                  id="site"
                  v-model="formData.website"
                  :class="{'border-danger':(Object.keys(errorsBag).includes('website'))}"
              >
            </div>

            <div class="col-12 pb-2" v-for="(langCode, index) in options.available_languages" :key="index">
              <label :for="'description_'+index" class="col-form-label">
                {{ $t("flexben.general.description") }} - {{ langCode }}
              </label>
              <span
                  :id="'description_tooltip_'+index"
                  class="d-inline-block flexben-tooltip-icon ml-2 text-bold"
              >
                i
              </span>
              <b-tooltip :target="'description_tooltip_'+index" variant="flexben" placement="topleft">
                <div class="text-left">{{ $t("flexben.brand.tooltips.description") }}</div>
              </b-tooltip>
              <p v-if="Object.keys(errorsBag).includes('description.'+langCode)" class="text-danger">
                {{errorsBag['description.'+langCode][0]}}
              </p>
              <v-editor
                :id="'description_'+index" rows="5"
                class="form-control-textarea my-0"
                :placeholder="$t('flexben.brand.fields.description_placeholder')"
                v-model="formData.description[langCode]"
                :editorToolbar="descriptionEditorToolbar"
                :class="{'border-danger':(Object.keys(errorsBag).includes('description|'+langCode))}"
              />
            </div>

            <div class="col-12 form-group">
              <label for="address" class="col-form-label">
                {{ $t('flexben.brand.fields.scope_availability') }}
              </label>
              <div v-for="(item, key) of options.scope_availability" :key="key" class="d-flex">
                <input
                    type="checkbox"
                    :value="item"
                    :id="'scope_availability_'+item"
                    :checked="formData.scope_availability.includes(item)"
                    @change="toggleScopeAvailability(item)"
                    class="mr-2 cursor-pointer"
                />
                <label :for="'scope_availability_'+item" class="text-14 mb-0 cursor-pointer">
                  {{ $t('flexben.brand.scope_availability.'+item) }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <brand-nav-tree-mappings
        v-if="formAction === 'update' && navTreeData && itemId"
        ref="brandNavTreeMappings"
        :brand-id="itemId"
        :nav-tree-data="navTreeData"
    />
    <div class="container-bg-white mt-3">
      <div class="row p-3">
        <div class="col-12">
          <h3 class="m-0 pl-0">{{ $t('flexben.partner.assigned_benefits') }}</h3>
        </div>
        <div class="col-12">
          <h4 class="m-0 pl-0">{{ $t('flexben.brand.rules.title') }}</h4>
          <ul>
            <li>{{ $t('flexben.brand.rules.1') }}</li>
            <li>{{ $t('flexben.brand.rules.2') }}</li>
            <li>{{ $t('flexben.brand.rules.3') }}</li>
            <li>{{ $t('flexben.brand.rules.4') }}</li>
            <li>{{ $t('flexben.brand.rules.5') }}</li>
            <li>{{ $t('flexben.brand.rules.6') }}</li>
            <li>{{ $t('flexben.brand.rules.7') }}</li>
          </ul>
        </div>
        <div class="col-12">
          <div class="table-responsive scaled-table">
            <table class="table table-striped">
              <thead>
              <tr>
                <td>{{ $t("flexben.general.name") }}</td>
                <td>{{ $t("flexben.brand.fields.value_discount") }}</td>
                <td>{{ $t("flexben.benefit.fields.sub_type") }}</td>
                <td>{{ $t("flexben.brand.fields.provider") }}</td>
                <td>{{ $t("flexben.benefit.fields.status") }}</td>
                <td>{{ $t("flexben.brand.fields.is_active_app") }}</td>
                <td>{{ $t("flexben.brand.fields.actions") }}</td>
              </tr>
              </thead>
              <tbody v-if="assignedBenefits.length>0">
              <tr v-for="item in assignedBenefits" :key="item.id">
                <td>{{ item.name }}</td>
                <td>
                  <ul>
                    <li>{{ $t("flexben.brand.fields.discount_items.price") }}: {{ item.value ? item.value.price : '-' }}</li>
                    <li v-if="item.value && item.value.total_discount">{{ $t("flexben.brand.fields.discount_items.discount") }}: {{item.value.total_discount}}</li>
                    <li v-if="item.value && item.value.platform_fee">{{ $t("flexben.brand.fields.discount_items.platform_discount") }}: {{item.value.platform_fee}}</li>
                    <li v-if="item.value && item.value.user_discount">{{ $t("flexben.brand.fields.discount_items.user_discount") }}: {{item.value.user_discount}}</li>
                  </ul>
                </td>
                <td>{{ item.sub_type ? $t("flexben.benefit.sub_types." + item.sub_type) : '-'}}</td>
                <td>{{ item.provider || '-' }}</td>
                <td>
                  <span :class="'benefit-status-'+item.status.toLocaleLowerCase()" class="benefit-status m-0">{{ $t("flexben.general.status_type." + item.status.toLocaleLowerCase()) }}</span>
                </td>
                <td>
                  <span :class="(item.is_available) ? 'benefit-status-active' : 'benefit-status-inactive'" class="benefit-status m-0">
                    {{ (item.is_available) ? $t("flexben.general.status_type.active") : $t("flexben.general.status_type.inactive") }}
                  </span>
                </td>
                <td>
                  <div class="d-flex justify-content-between brand-benefit-actions" v-if="item.status.toLocaleLowerCase() !== 'inactive'">
                    <div class="brand-benefit-action-buttons">
                      <label for="address" class="col-form-label pt-0 text-bold form-fields-required">
                        {{ $t('flexben.brand.fields.scope_availability') }}
                      </label>
                      <div>
                        <input
                            type="checkbox"
                            :id="'scope_availability_'+item.id"
                            :checked="isAvailabilityChecked(item)"
                            :disabled="isAvailabilityDisabled(item)"
                            class="mr-2 cursor-pointer"
                            @change="onAvailabilityToggle(item, $event.target.checked)"
                        />
                      </div>
                    </div>
                    <div style="display: grid">
                      <label class="col-form-label pt-0 text-bold form-fields-required"
                             for="start_use_date">{{$t("flexben.offers.fields.start_date")}}</label>
                      <div class="d-inline-flex">
                        <label for="start_use_date" class="my-auto mr-2 col-form-label">
                          <font-awesome-icon icon="calendar-alt" class="text-24 "  :style="{color: item.start_use_date && item.end_use_date ? '#cccccc!important' : '#585858'}"/>
                        </label>
                        <div>
                          <datepicker :format="dateFormat"
                                      v-model="item.start_use_date"
                                      :inputClass="{'form-control-d m-0 w-100 background-white':true, 'border-danger': hasBenefitError(item.id, 'start')}"
                                      :class="{'w-100':true}"
                                      :key="'start-' + item.id + '-' + item._dpKeyStart"
                                      :id="'start_use_date_' + item.id"
                                      :disabledDates="disableUntil"
                                      @opened="setActiveRow(item.id)"
                                      @input="onStartDateChange(item)"
                          ></datepicker>
                          <p v-if="hasBenefitError(item.id, 'start')" class="text-danger mb-0">
                            {{ benefitDateErrors[item.id].start }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div style="display: grid">
                      <label class="col-form-label pt-0 text-bold form-fields-required"
                             for="end_use_date">{{$t("flexben.offers.fields.end_date")}}</label>
                      <div class="d-inline-flex">
                        <label for="end_use_date" class="my-auto mr-2 col-form-label">
                          <font-awesome-icon icon="calendar-alt" class="text-24 "  :style="{color: item.start_use_date && item.end_use_date && activeBenefitId === item.id ? '#cccccc!important' : '#585858'}"/>
                        </label>
                        <div>
                          <datepicker :format="dateFormat"
                                      v-model="item.end_use_date"
                                      :inputClass="{'form-control-d m-0 w-100 background-white':true, 'border-danger': hasBenefitError(item.id, 'end')}"
                                      :class="{'w-100':true}"
                                      :key="'end-' + item.id + '-' + item._dpKeyEnd"
                                      :disabledDates="getEndDisabledDates(item)"
                                      :id="'end_use_date_' + item.id"
                                      @input="onEndDateChange(item)"
                                      @opened="setActiveRow(item.id)"></datepicker>
                          <p v-if="hasBenefitError(item.id, 'end')" class="text-danger mb-0">
                            {{ benefitDateErrors[item.id].end }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div style="display: grid">
                      <button
                          v-if="item._dirty"
                          type="button"
                          class="btn action-button justify-content-end h-100"
                          @click="saveBenefitRow(item)"
                      >
                        {{$t("flexben.general.btn.save")}}
                      </button>

                      <button
                          v-if="item._dirty"
                          type="button"
                          class="btn action-button justify-content-end h-100"
                          style="background:#dc3545!important;color:white!important;"
                          @click="revertRow(item)"
                      >
                        {{$t("flexben.requests.action.cancel")}}
                      </button>

                      <button
                          v-else-if="item._serverHasDates || item._serverHasAvailability"
                          type="button"
                          class="btn action-button justify-content-end h-100"
                          style="background:#dc3545!important;color:white!important;"
                          @click="clearRemote(item)"
                      >
                        {{$t("flexben.requests.action.cancel")}}
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
              </tbody>
              <tbody v-else>
              <tr class="trhover gri-cell">
                <td class="text-center" colspan="7">{{ $t('flexben.partner.no_assigned_benefits') }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <confirm-modal
        :action="modal.action"
        :formSuccess="modal.formSuccess"
        :message="modal.message"
        :canDelete="modal.canDelete"
        ref="confirm-modal"
        @confirmAction="confirmAction"
    >
    </confirm-modal>
    <content-loader :loader-visible="this.loading" :loader-error="loaderError" />
  </div>
</template>

<script>
import FormErrorList from "@/components/fragments/FormErrorList";
import httpFlexbenService from "@/http/http-flexben";
import ConfirmModal from "@/components/flexben/brands/modals/ConfirmModal";
import BrandNavTreeMappings from "@/components/flexben/brands/BrandNavTreeMappings";
import {BTooltip} from "bootstrap-vue";
import {VueEditor} from "vue2-editor";
import vueEditorSettings from "@/constants/vue_editor_settings";
import {multilangColorValidationErrors} from "@/helpers/descriptionSanitizer";
import Datepicker from "vuejs-datepicker";
import moment from "moment/moment";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

export default {
  name: "BrandForm",
  components: {
    "form-error-list": FormErrorList,
    "confirm-modal": ConfirmModal,
    "brand-nav-tree-mappings": BrandNavTreeMappings,
    'b-tooltip': BTooltip,
    'v-editor': VueEditor,
    'datepicker': Datepicker,
    vue2Dropzone
  },
  props: {
    itemId: {
      required: false,
      type: Number,
    },
    formAction: {
      type: String,
      required: true,
    },
    options: {
      required: true,
      type: Object,
    },
  },
  computed: {
    dropzoneOptions() {
      return {
        icon: {
          url: "https://httpbin.org/post",
          height: 120,
          thumbnailWidth: 300,
          maxFiles: 1,
          addRemoveLinks: true,
          autoProcessQueue: false
        },
        image: {
          url: "https://httpbin.org/post",
          height: 220,
          thumbnailWidth: 220,
          maxFiles: 1,
          addRemoveLinks: true,
          autoProcessQueue: false
        },
        cover: {
          url: "https://httpbin.org/post",
          height: 280,
          thumbnailWidth: 280,
          maxFiles: 1,
          addRemoveLinks: true,
          autoProcessQueue: false
        }
      };
    }
  },
  data: () => {
    return {
      activeBenefitId: null,
      benefitDateErrors: {},
      dateFormat: 'dd/MM/yyyy',
      disableUntil: {to: moment().startOf('day').toDate()},
      httpService: httpFlexbenService.brandService,
      editorToolbar: vueEditorSettings.editorToolbar,
      descriptionEditorToolbar: vueEditorSettings.descriptionEditorToolbar,
      loading: false,
      loaderError: false,
      imageChanged: false,
      showOptionalMedia: false,
      benefitsCount: 0,
      assignedBenefits: [],
      isFormModified: false,
      isInitializingForm: true,
      iconValidationPending: false,
      suppressIconRemoved: false,
      existingFiles: {
        icon_url: null
      },
      formData: {
        id: null,
        name: null,
        website: null,
        icon_url: null,
        description: {},
        scope_availability: [],
      },
      modal: {
        action: '',
        formSuccess: true,
        message: '',
        canDelete: true,
      },
      errors: {
        icon_url: null,
      },
      errorsBag: {},
      navTreeData: null,
    };
  },
  watch: {
    formData: {
      deep: true,
      handler: function () {
        if (this.isInitializingForm) {
          return;
        }
        this.isFormModified = true;
      }
    }
  },
  created() {
    this.initializeDescriptions();

    if (!this.itemId) {
      this.$nextTick(() => {
        this.isInitializingForm = false;
        this.isFormModified = false;
      });
      return;
    }

    this.loading = true;

    const instance = this;

    this.httpService.details(this.itemId).then(function (response) {
      response = response.data;

      const previewImage = this.getBrandPreviewImage(response.data.brand);
      this.existingFiles.icon_url = previewImage;

      if (previewImage) {
        this.addBrandPreviewToDropzone(previewImage);
      }

      this.benefitsCount = response.data.benefitsCount;
      if (this.benefitsCount) {
        this.modal.canDelete = false;
      }
      this.formData.name = response.data.brand.name;
      this.formData.website = response.data.brand.website;
      for (let index in this.options.available_languages) {
        let langCode = this.options.available_languages[index];
        this.$set(this.formData.description, langCode, response.data.brand.description
            ? response.data.brand.description[langCode]
            : ''
        );
      }
      this.formData.scope_availability = response.data.brand.scope_availability ? response.data.brand.scope_availability : [];
      this.navTreeData = response.data.nav_tree || null;
    }.bind(this)).then(function () {
      this.isFormModified = false;
      this.isInitializingForm = false;
      instance.reloadBenefitsTable(instance);
    }.bind(this)).catch(function () {
      this.isInitializingForm = false;
      this.loading = false;
      this.loaderError = true;
    }.bind(this));
  },
  methods: {
    initializeDescriptions() {
      for (let index in this.options.available_languages) {
        let langCode = this.options.available_languages[index];
        this.$set(this.formData.description, langCode, this.formData.description[langCode] || '');
      }
    },

    getBrandPreviewImage(brand) {
      if (!brand) {
        return null;
      }

      return brand.icon_url || brand.image || null;
    },

    addBrandPreviewToDropzone(previewImage) {
      this.$nextTick(() => {
        if (!this.$refs.iconUrlRef) {
          return;
        }

        const mockFile = { size: 100, name: "Icon", type: "image/*" };

        this.$refs.iconUrlRef.manuallyAddFile(mockFile, previewImage);

        if (this.$refs.iconUrlRef.dropzone) {
          this.$refs.iconUrlRef.dropzone.emit("thumbnail", mockFile, previewImage);
          this.$refs.iconUrlRef.dropzone.emit("complete", mockFile);
        }
      });
    },

    getNewFile(refName) {
      const ref = this.$refs[refName];
      if (!ref) return null;

      const acceptedFiles = ref.getAcceptedFiles ? ref.getAcceptedFiles() : [];
      if (!acceptedFiles.length) return null;

      const firstFile = acceptedFiles[0];

      if (firstFile && firstFile.name && !(firstFile instanceof File)) {
        return null;
      }

      return firstFile instanceof File ? firstFile : null;
    },

    hasExistingOrNewIcon() {
      const newIcon = this.getNewFile("iconUrlRef");
      return !!(newIcon || this.existingFiles.icon_url);
    },

    onIconAdded(file) {
      this.errors.icon_url = null;
      if (Object.prototype.hasOwnProperty.call(this.errorsBag, "icon_url")) {
        this.$delete(this.errorsBag, "icon_url");
      }

      if (!file || file.manuallyAdded || !(file instanceof File)) {
        return;
      }

      this.validateIconFile(file);
    },

    onIconRemoved() {
      if (this.suppressIconRemoved) {
        return;
      }

      this.existingFiles.icon_url = null;
      this.errors.icon_url = null;
    },

    validateIconFile(file) {
      this.iconValidationPending = true;

      if (file.type !== 'image/png') {
        this.rejectIconFile(file, this.getIconValidationMessage('type'));
        return;
      }

      if (file.size > 2 * 1024 * 1024) {
        this.rejectIconFile(file, this.getIconValidationMessage('size'));
        return;
      }

      const reader = new FileReader();

      reader.onload = (event) => {
        const image = new Image();

        image.onload = () => {
          const hasValidDimensions = (image.width === 600 && image.height === 600)
              || (image.width === 600 && image.height === 300);

          if (!hasValidDimensions) {
            this.rejectIconFile(file, this.getIconValidationMessage('dimensions'));
            return;
          }

          this.iconValidationPending = false;
          this.errors.icon_url = null;
        };

        image.onerror = () => {
          this.rejectIconFile(file, this.getIconValidationMessage('invalid'));
        };

        image.src = event.target.result;
      };

      reader.onerror = () => {
        this.rejectIconFile(file, this.getIconValidationMessage('invalid'));
      };

      reader.readAsDataURL(file);
    },

    rejectIconFile(file, message) {
      this.errors.icon_url = message;
      this.iconValidationPending = false;

      if (!this.$refs.iconUrlRef) {
        return;
      }

      this.suppressIconRemoved = true;
      this.$refs.iconUrlRef.removeFile(file);
      this.$nextTick(() => {
        this.suppressIconRemoved = false;
      });
    },

    getIconValidationMessage(type) {
      const messages = {
        type: 'flexben.brand.errors.icon_png_required',
        size: 'flexben.brand.errors.icon_max_size',
        dimensions: 'flexben.brand.errors.icon_dimensions',
        pending: 'flexben.brand.errors.icon_validation_pending',
        invalid: 'flexben.brand.errors.icon_invalid',
      };

      return this.$t(messages[type] || messages.invalid);
    },

    revertRow(item) {
      const start = (item._initial && item._initial.start_use_date) ? new Date(item._initial.start_use_date) : null;
      const end = (item._initial && item._initial.end_use_date) ? new Date(item._initial.end_use_date) : null;
      const avail = !!item._initial.availability;

      this.$set(item, 'start_use_date', start);
      this.$set(item, 'end_use_date', end);
      this.$set(item, 'availability', avail);

      if (start && end) this.$set(item, 'availability', false);

      item._dirty = false;
      this.$delete(this.benefitDateErrors, item.id);

      this.$nextTick(() => {
        this.$set(item, '_dpKeyStart', (item._dpKeyStart || 0) + 1);
        this.$set(item, '_dpKeyEnd', (item._dpKeyEnd || 0) + 1);
      });
    },

    reloadBenefitsTable(instance) {
      instance.loading = true;
      return instance.httpService.getBenefits(this.itemId).then(function (response) {
        instance.assignedBenefits = (response.data.data || []).map(b => {
          const serverHasDates = !!(b.start_use_date && b.end_use_date);
          const serverHasAvailability = !!b.availability && !serverHasDates;

          return {
            ...b,
            _serverHasDates: serverHasDates,
            _serverHasAvailability: serverHasAvailability,
            _dirty: false,
            _dpKeyStart: 1,
            _dpKeyEnd: 1,
            _initial: {
              availability: !!b.availability,
              start_use_date: b.start_use_date ? new Date(b.start_use_date) : null,
              end_use_date: b.end_use_date ? new Date(b.end_use_date) : null,
            },

            start_use_date: b.start_use_date ? new Date(b.start_use_date) : null,
            end_use_date: b.end_use_date ? new Date(b.end_use_date) : null,

            availability: serverHasDates ? false : !!b.availability,
          };
        });

        instance.loading = false;
      }).catch(function () {
        instance.loading = false;
        instance.loaderError = true;
      });
    },

    setActiveRow(benefitId) {
      if (!benefitId) return;

      if (this.activeBenefitId && this.activeBenefitId !== benefitId) {
        this.clearUnsavedDates(this.activeBenefitId);
      }
      this.activeBenefitId = benefitId;
    },

    clearUnsavedDates(benefitId) {
      const row = this.assignedBenefits.find(b => b.id === benefitId);
      if (!row) return;
      if (row._dirty && !row._serverHasDates && !row._serverHasAvailability) {
        row.start_use_date = null;
        row.end_use_date = null;
        row.availability = false;
        row._dirty = false;
      }
      this.$delete(this.benefitDateErrors, benefitId);
    },

    getEndDisabledDates(item) {
      if (item.start_use_date) {
        return { to: item.start_use_date };
      }
      return this.disableUntil;
    },

    hasBenefitError(benefitId, field) {
      return !!(this.benefitDateErrors[benefitId] && this.benefitDateErrors[benefitId][field]);
    },

    isAvailabilityChecked(item) {
      return !!item.availability && !item.start_use_date && !item.end_use_date;
    },

    isAvailabilityDisabled(item) {
      return !!item.start_use_date || !!item.end_use_date || !!item._serverHasDates;
    },

    onAvailabilityToggle(item, checked) {
      item._dirty = true;

      if (checked) {
        item.start_use_date = null;
        item.end_use_date = null;
        item.availability = true;
      } else {
        item.availability = false;
      }

      this.$delete(this.benefitDateErrors, item.id);
    },

    onStartDateChange(item) {
      item._dirty = true;
      item.end_use_date = null;
      item.availability = false;
      this.$delete(this.benefitDateErrors, item.id);
    },

    onEndDateChange(item) {
      item._dirty = true;
      item.availability = false;
      this.$delete(this.benefitDateErrors, item.id);
    },

    validateRow(item) {
      this.$delete(this.benefitDateErrors, item.id);

      if (!item.start_use_date && item.end_use_date) {
        this.$set(this.benefitDateErrors, item.id, {
          start: this.$t('flexben.brand.errors.start_date'),
        });
        return false;
      }

      if (item.start_use_date && !item.end_use_date) {
        this.$set(this.benefitDateErrors, item.id, {
          end: this.$t('flexben.brand.errors.end_date'),
        });
        return false;
      }
      return true;
    },

    formatDatePayload(date) {
      return date ? moment(date).format('YYYY-MM-DD') : null;
    },

    async saveBenefitRow(item) {
      if (!this.validateRow(item)) return;

      const hasDates = !!(item.start_use_date && item.end_use_date);
      const availability = hasDates ? false : !!item.availability;

      this.loading = true;

      try {
        await this.httpService.saveBenefitDatesAvailable(this.itemId, {
          benefit_id: item.id,
          availability,
          start_use_date: this.formatDatePayload(item.start_use_date),
          end_use_date: this.formatDatePayload(item.end_use_date)
        });

        await this.reloadBenefitsTable(this);
      } catch (error) {
        this.loading = false;
        this.loaderError = true;
      }
    },

    clearLocal(item) {
      this.$set(item, 'start_use_date', null);
      this.$set(item, 'end_use_date', null);
      this.$set(item, 'availability', false);

      this.$set(item, '_dpKeyStart', (item._dpKeyStart || 0) + 1);
      this.$set(item, '_dpKeyEnd', (item._dpKeyEnd || 0) + 1);

      item._dirty = false;
      this.$delete(this.benefitDateErrors, item.id);
    },

    async clearRemote(item) {
      this.loading = true;

      try {
        await this.httpService.removeBenefitDatesAvailable(this.itemId, item.id);
        await this.reloadBenefitsTable(this);
      } catch (error) {
        this.loading = false;
        this.loaderError = true;
      }
    },

    goBack() {
      if (this.isFormModified) {
        this.modalAct('go_back')
      } else {
        this.$emit('clearForm');
      }
    },

    confirmAction(action) {
      if (action === 'go_back') {
        this.isFormModified = false;
        this.goBack();
      }
      this.closeModal();
      if (action === 'form_submit') {
        this.save();
      }
      if (action === 'delete') {
        this.delete();
      }
      if (action === 'end') {
        this.goBack();
      }
    },

    modalAct(action) {
      this.modal.message = '';
      if (action === 'delete' && this.benefitsCount) {
        this.modal.message = this.$t('flexben.brand.modal.extra_delete', {count_benefits: this.benefitsCount});
      }
      this.modal.action = action;
      this.openModal();
    },

    openModal() {
      this.$refs['confirm-modal'].openModal();
    },

    closeModal() {
      this.$refs['confirm-modal'].closeModal();
    },

    _prepareFormData() {
      let formData = new FormData();
      const iconFile = this.getNewFile("iconUrlRef");

      if (this.formData.name) {
        formData.append('name', this.formData.name);
      }
      if (this.formData.website) {
        formData.append('website', this.formData.website);
      }
      if (this.formData.image) {
        formData.append('image', this.formData.image);
      }
      if (iconFile) {
        formData.append('icon_url', iconFile);
      }

      formData.append('description', JSON.stringify(this.formData.description));
      formData.append('scope_availability', JSON.stringify(this.formData.scope_availability));

      return formData;
    },

    _appendDescriptionColorErrors() {
      const colorErrors = multilangColorValidationErrors(
        this.formData.description,
        this.options.available_languages
      );

      this.errorsBag = {
        ...this.errorsBag,
        ...colorErrors,
      };

      return Object.keys(colorErrors).length === 0;
    },
    save() {
      if (this.iconValidationPending) {
        this.errors.icon_url = this.getIconValidationMessage('pending');
        return;
      }

      if (this.errors.icon_url) {
        return;
      }

      if (!this.hasExistingOrNewIcon()) {
        this.errors.icon_url = this.$t("flexben.brand.errors.icon_required");
        return;
      }

      if (this.loading) {
        return;
      }

      if (this.iconValidationPending) {
        this.errors.icon_url = this.getIconValidationMessage('pending');
        return;
      }

      if (this.errors.icon_url) {
        return;
      }

      if (!this.hasExistingOrNewIcon()) {
        this.errors.icon_url = this.$t("flexben.brand.errors.icon_required");
        return;
      }

      this.errorsBag = {};

      if (!this._appendDescriptionColorErrors()) {
        return;
      }

      this.loading = true;
      this.httpService.save(this.itemId, this._prepareFormData())
          .then(function () {
            this.modal.formSuccess = true;
            this.modal.action = 'end';
            this.loading = false;
            this.isFormModified = false;
            this.openModal();
          }.bind(this))
          .catch(function (error) {
            if (error.response.status === 400) {
              this.errorsBag = error.response.data.error_fields;
              this.modal.formSuccess = false;
              this.modal.message = this.$t('flexben.general.validation_errors');
              this.modal.action = 'end';
              this.loading = false;
              this.openModal();
            } else {
              this.loading = false;
              this.loaderError = true;
            }
          }.bind(this));
    },

    delete() {
      this.loading = true;
      this.httpService.delete(this.itemId)
          .then(function (response) {
            this.modal.formSuccess = true;
            this.modal.action = 'end';
            this.modal.message = '';
            this.loading = false;
            this.openModal();
          }.bind(this))
          .catch(function (error) {
            if (error.response.status === 400) {
              this.loading = false;
              this.loaderError = true;
            }
          }.bind(this));
    },

    setImageFile() {
      this.errorsBag = {};
      if (this.$refs.image_input.accept.indexOf(this.$refs.image_input.files[0].type.split('/')[1]) > 0) {
        let reader = new FileReader();
        reader.readAsDataURL(this.$refs.image_input.files[0]);
        reader.onload = evt => {
          let img = new Image();
          img.onload = () => {
            if (img.width !== img.height) {
              this.errorsBag = {image: 'image_square'};
            } else if (img.width !== 500 || img.height !== 500) {
              this.errorsBag = {image: 'image_500_500'};
            } else {
              this.formData.image = this.$refs.image_input.files[0];
              this.imageChanged = true;
              if (typeof this.formData.image !== "undefined") {
                this.imagePreview = URL.createObjectURL(this.formData.image);
              }
            }
          }
          img.src = evt.target.result;
        }
      } else {
        this.errorsBag = {image: 'image_type_supported'};
      }
    },

    toggleScopeAvailability(item) {
      if (this.formData.scope_availability.includes(item)) {
        this.formData.scope_availability.splice(this.formData.scope_availability.indexOf(item), 1);
      } else {
        this.formData.scope_availability.push(item);
      }
    },

    remove(benefit_id) {
      this.loading = true;
      this.httpService.removeBenefitDatesAvailable(this.itemId, benefit_id).then(response => {
        this.reloadBenefitsTable(this);
        this.loading = false;
      });
    }
  },
}
</script>

<style lang="scss">
.brand-form-media {
  .form-group {
    margin-bottom: 1rem;

    .label-input {
      font-weight: 700;
      font-size: .85rem;
      color: #2d3748;
    }
  }

  .form-control,
  .form-control-textarea {
    border: 1px solid #d9e2ec;
    border-radius: 10px;
    padding: 10px 12px;
    transition: border-color .2s ease, box-shadow .2s ease;
    background: #fff;
  }

  .form-control:focus,
  .form-control-textarea:focus {
    outline: none;
    border-color: #8aa4ff;
    box-shadow: 0 0 0 3px rgba(138, 164, 255, 0.15);
  }

  .upload-card {
    background: #fff;
    border: 1px solid #e7edf3;
    border-radius: 16px;
    box-shadow: 0 8px 24px rgba(16, 24, 40, 0.06);
    overflow: hidden;
  }

  .primary-upload-card {
    border: 1px solid #d8e4ff;
    background: linear-gradient(180deg, #f8fbff 0%, #ffffff 100%);
  }

  .optional-upload-card {
    border-style: dashed;
  }

  .upload-card-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
    padding: 16px 18px 0;
  }

  .upload-title {
    font-size: 1rem;
    font-weight: 700;
    color: #101828;
  }

  .upload-subtitle {
    font-size: .82rem;
    color: #667085;
  }

  .required-badge {
    background: #eef4ff;
    color: #3559e0;
    border: 1px solid #dbe5ff;
    border-radius: 999px;
    padding: 4px 10px;
    font-size: .72rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: .04em;
  }

  .upload-card-body {
    padding: 18px;
  }

  .optional-toggle {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: transparent;
    border: none;
    padding: 16px 18px;
    font-size: .95rem;
    font-weight: 700;
    color: #344054;
    cursor: pointer;
  }

  .optional-toggle:focus {
    outline: none;
  }

  .optional-media-block + .optional-media-block {
    margin-top: 8px;
  }

  .brand-benefit-actions {
    gap: 16px;
    min-width: 560px;
  }

  .brand-benefit-action-buttons {
    display: grid;
    gap: 8px;
    align-content: start;
  }

  .dropzone {
    border: none !important;
    min-height: auto !important;
    padding: 0 !important;
    background: transparent !important;
  }

  .vue-dropzone {
    display: flex;
    justify-content: center;
    border: 2px dashed #cfd8e3 !important;
    border-radius: 14px !important;
    background: #fbfdff !important;
    padding: 10px !important;
    min-height: 140px;
    transition: border-color .2s ease, background .2s ease;
  }

  .vue-dropzone:hover {
    border-color: #97a6ba !important;
    background: #f7fbff !important;
  }

  #iconUrl.vue-dropzone {
    min-height: 160px;
    background: linear-gradient(180deg, #f8fbff 0%, #fdfefe 100%) !important;
  }

  .vue-dropzone .dz-message {
    margin: auto !important;
    color: #667085;
    font-weight: 600;
    font-size: .9rem;
    text-align: center;
  }

  .vue-dropzone > .dz-preview {
    margin: 10px;
  }

  .vue-dropzone > .dz-preview .dz-remove {
    font-size: .72rem;
    margin-top: 8px;
    color: #c0392b;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .2s ease;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>
